<template>
  <v-card :loading="loading" class="pa-4" flat>
    <custom-tabs
      v-model="tabs"
      :tab-items="[
        { text: 'ارسال شده', icon: 'send-check' },
        { text: 'ارسال در آینده', icon: 'calendar-clock' },
      ]"
      grow
    >
      <template v-slot:staticItems>
        <v-tabs-items v-model="tabs">
          <v-tab-item>
            <!--        <v-card-title class="justify-end">-->
            <!--          <v-btn :disabled="!selectedRow.length" class="btn btn-accept ma-0" depressed>-->
            <!--            خرید شماره-->
            <!--          </v-btn>-->
            <!--        </v-card-title>-->

            <vue-table
              v-model="selectedRow"
              :data="data"
              :headers="headers"
              :loading.sync="loading"
              @change="onPagination"
            >
              <template v-slot:filters="{ perPage, props }">
                <v-row class="px-2" no-gutters>
                  <v-flex class="p-2" lg3 md3 sm12 xl3 xs12>
                    <v-select
                      v-model="props.length"
                      :items="perPage"
                      :menu-props="{ offsetY: true }"
                      dense
                      item-text="page"
                      item-value="page"
                      outlined
                    />
                  </v-flex>

                  <v-flex class="p-2" lg3 md3 sm12 xl3 xs12>
                    <v-text-field
                      v-model="props.search"
                      append-icon="mdi-magnify"
                      dense
                      label="جستجو"
                      outlined
                    />
                  </v-flex>

                  <v-flex class="p-2" lg3 md3 sm12 xl3 xs12>
                    <custom-date-picker
                      v-model="props.followup_date"
                      append-icon="mdi-calendar-month"
                      dense
                      format="YYYY-MM-DD"
                      hide-details
                      input-class="fu-date"
                      label="تاریخ پیگیری"
                      nullable
                      outlined
                      type="date"
                    />
                  </v-flex>

                  <v-flex class="p-2" lg3 md3 sm12 xl3 xs12>
                    <custom-date-picker
                      v-model="props.delivered_at"
                      append-icon="mdi-calendar-month"
                      dense
                      format="YYYY-MM-DD"
                      hide-details
                      input-class="da-date"
                      label="تاریخ ارسال"
                      nullable
                      outlined
                      type="date"
                    />
                  </v-flex>
                </v-row>
              </template>

              <template v-slot:index="{ item }">
                {{ item.index + 1 + (data.current_page - 1) * data.per_page }}
              </template>

              <template v-slot:hour="{ item }">
                {{ getTime(item.delivered_at_p) }}
              </template>

              <template v-slot:date="{ item }">
                {{ datetime(item.delivered_at, "date") }}
              </template>

              <template v-slot:followup_text="{ item }">
                <edit-report-status :data="item" />
              </template>

              <template v-slot:followup_date="{ item }">
                <edit-report-date :data="item" />
              </template>

              <template v-slot:phone="{ item }">
                <div style="direction: ltr">{{ item.phone }}</div>
              </template>

              <template v-slot:advertise="{ item }">
                <!-- <a
                  :href="`https://divar.ir/v/${str_random(item.advertise)}`"
                  dir="ltr"
                  target="_blank"
                  >مشاهده آگهی</a
                > -->
                  <a
                  :href="`https://divar.ir/v/${item.advertise}`"
                  dir="ltr"
                  target="_blank"
                  >مشاهده آگهی</a
                >

              </template>
            </vue-table>
          </v-tab-item>

          <v-tab-item>
            <data-table
              :columns="columns"
              :data="futureData"
              :debounce-delay="5000"
              :per-page="[10, 25, 50, 100, 400]"
              :translate="translate"
              orderDir="desc"
              @on-table-props-changed="reloadTable"
            >
              <template slot="filters" slot-scope="{ tableFilters, perPage }">
                <v-row class="px-2" no-gutters>
                  <v-flex class="p-2" lg3 md3 sm12 xl3 xs12>
                    <v-select
                      v-model="tableFilters.length"
                      :items="perPage"
                      :menu-props="{ offsetY: true }"
                      dense
                      item-text="page"
                      item-value="page"
                      outlined
                    />
                  </v-flex>

                  <v-flex class="p-2" lg3 md3 sm12 xl3 xs12>
                    <v-text-field
                      v-model="tableFilters.search"
                      append-icon="mdi-magnify"
                      dense
                      label="جست و جو"
                      outlined
                    />
                  </v-flex>
                </v-row>
              </template>
            </data-table>
          </v-tab-item>
        </v-tabs-items>
      </template>
    </custom-tabs>
  </v-card>
</template>

<script>
import EditReportStatus from "@/view/pages/divar/report/editReportStatus.vue";
import EditReportDate from "@/view/pages/divar/report/editReportDate.vue";
import CustomDatePicker from "@/core/plugins/TitleRibbon/pages/pickers/custom-date-picker.vue";

export default {
  name: "Sended",

  components: {
    CustomDatePicker,
    EditReportStatus,
    EditReportDate,
  },

  props: ["id"],

  data() {
    return {
      tabs: 0,
      headers: [
        { value: "index", text: "ردیف", sortable: false, align: "center" },
        {
          value: "msgId",
          text: "کد وضعیت اپراتور",
          sortable: false,
          align: "center",
        },
        { value: "hour", text: "ساعت", sortable: false, align: "center" },
        { value: "date", text: "تاریخ", sortable: false, align: "center" },
        {
          value: "followup_text",
          text: "وضعیت پیگیری",
          sortable: false,
          align: "center",
        },
        {
          value: "followup_date",
          text: "تاریخ پیگیری",
          sortable: false,
          align: "center",
        },
        { value: "phone", text: "گیرنده", sortable: false, align: "center" },
        { value: "advertise", text: "آگهی", sortable: false, align: "center" },
      ],
      translate: {
        nextButton: "بعدی",
        previousButton: "قبلی",
        rowsPerPageText: "تعداد در صفحه",
        noDataText: "داده ای برای نمایش وجود ندارد",
        placeholderSearch: "جستجو",
      },
      tableProps: {
        page: 1,
        search: "",
        length: 10,
        column: "id",
        dir: "desc",
      },
      selectedRow: [],
      data: {},
      futureData: [],
      loading: false,
    };
  },

  mounted() {
    this.getUserReportsSms();
  },

  computed: {
    url() {
      return "task/smsReports/" + this.id;
    },
  },

  methods: {
    async getUserReportsSms(props = this.tableProps) {
      this.loading = true;

      if (this.tabs > 0) props.future = true;
      else if (props.hasOwnProperty("future")) delete props.future;

      await this.requestApiPost(this.url, props)
        .then(({ data }) => {
          if (!!this.tabs) this.futureData = data.data;
          else {
            this.data = data.data;
          }
        })
        .catch(() => {
          this.$modal.info(this.$t(""), this.$t("INFOS.NoReport"));
        })
        .finally(() => (this.loading = false));
    },
    onPagination(e) {
      let props = {
        ...this.tableProps,
        ...e,
      };

      this.getUserReportsSms(props);
    },
    reloadTable(tableProps) {
      this.getUserReportsSms(tableProps);
    },
    str_random(input) {
      const characters = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";

      const randomInd = Math.floor(Math.random() * characters.length);
      return input.slice(0, 3) + characters.charAt(randomInd) + input.slice(3);
    },
  },
};
</script>
